import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, model, OnDestroy, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { Messages } from 'src/app/common/enums';
import { EditWorkerRealizationDateRequest } from 'src/app/contracts/requests/orders/edit-worker-realization-date-request';
import { OrderService } from 'src/app/data/order.service';
import { OrderStartRealizationItemsDto } from 'src/app/models/dtos/orders/order-start-realization-items-dto';
import { SnackBarService } from 'src/app/shared/services/snack-bar.service';
@Component({
  selector: 'app-mass-worker-realization-date-edit-modal',
  templateUrl: './mass-worker-realization-date-edit-modal.component.html',
  styleUrl: './mass-worker-realization-date-edit-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class MassWorkerRealizationDateEditModalComponent {
  private orderService = inject(OrderService);
  private spinner = inject(NgxSpinnerService);
  private snackbarService = inject(SnackBarService);
  dialogRef = inject<MatDialogRef<MassWorkerRealizationDateEditModalComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  elementsCount: number;
  minDate: Date;
  maxDate: Date = new Date();
  selectedDate: Date = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());


  constructor() {
    const data = this.data;

    this.minDate = new Date(data[0].StartDate);
    this.elementsCount = data.length;
  }

  onSave(): void {
    if (!this.selectedDate) {
      return;
    }

    let req: EditWorkerRealizationDateRequest = {
      workerRealizationDate: this.selectedDate,
      workerOrderItemIds: this.data.map((s) => s.WorkerOrderItemId),
    };

    this.spinner.show();
    this.orderService.editWorkerRealizationDate(req).subscribe({
      next: () => {
        this.snackbarService.openSuccessSnackBar(Messages.MassSuccessfullyEditWorkerRealizationDate);
        this.dialogRef.close(true);
      },
      complete: () => this.spinner.hide(),
      error: (error: HttpErrorResponse) => {
        this.snackbarService.openErrorSnackBar(error.error);
        this.spinner.hide();
      },
    });
  }

  onClose(): void {
    this.dialogRef.close(false);
  }

  setDate(date: Date) {
    this.selectedDate = date;
  }
}
